const statusObj = {
  full: { name: 'เต็ม', color: '#228B90' },
  available: { name: 'ว่าง', color: '#D35C3B' }
}

export {
  statusObj
}
